import {Component, inject, OnInit, signal} from '@angular/core'
import {ActivatedRoute, Router} from '@angular/router'
import {filter, map, switchMap} from 'rxjs'
import {DatePipe, JsonPipe} from '@angular/common'
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from '@angular/material/card'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion'
import {LOCAL_STORAGE} from '../../0-general/providers'
import {AuthService} from '../../services/auth-service'
import {MatButton} from '@angular/material/button'
import {GitlabService} from '../../services/gitlab-service'
import {MatDialog, MatDialogRef} from '@angular/material/dialog'
import {IWaitDialog, WaitDialog} from '../../0-general/wait-dialog/wait-dialog'

@Component({
  selector: 'aku-logged-in',
  imports: [
    JsonPipe,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatExpansionPanel,
    MatAccordion,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatButton,
    MatCardSubtitle,
    DatePipe
  ],
  templateUrl: './logged-in.html',
  styleUrl: './logged-in.scss'
})
export class LoggedIn implements OnInit {
  /**
   * Just for show.
   */
  /* v8 ignore next @preserve */
  public readonly self = signal<any>(null)

  /**
   * To read query
   */
  private readonly route = inject(ActivatedRoute)

  /**
   * Make the code exchanged if called with parameter code=
   */
  public readonly authService = inject(AuthService)

  /**
   * Navigate to home and clear all query parameters
   */
  private readonly router = inject(Router)

  /**
   * For loading the nonce when relevant, not relevant on this
   * site but when invoked from others. Remove?
   */
  private readonly storage = inject(LOCAL_STORAGE)

  /**
   * More or less for testing purposes
   * @private
   */
  private readonly gitlabService = inject(GitlabService)

  /**
   * Show friendly message on exchange
   */
  private readonly dialog = inject(MatDialog)

  public ngOnInit() {
    let ref: MatDialogRef<WaitDialog>
    this.route.queryParamMap
      .pipe(
        map(params => params.get('code')),
        filter(Boolean),
        switchMap(code => {
          ref = this.dialog.open<WaitDialog, IWaitDialog, void>(WaitDialog, {
            data: {
              title: 'Authenticating',
              text: signal('Exchanging credentials...')
            },
            disableClose: true
          })
          return this.authService.exchange(code, this.storage.getItem('nonce')!)
        })
      )
      .subscribe(self => {
        this.self.set(self)
        this.router.navigate(['home'], {
          queryParams: {'code': null},
          queryParamsHandling: 'merge'
        }).then()
        ref.close()
      })
  }

  public getSelf() {
    this.authService.getSelf().subscribe(res => this.self.set(res))
  }

  public listGroups() {
    this.gitlabService.listGroups(true).subscribe()
  }
}
